import { useState } from "react";
import { useAuth } from "../../../../hooks/AuthContext";
import { useNavigate } from "react-router-dom";
import './Login.css';
import useAuths from '../../../../hooks/UseAuths';
export const Login = ()=>{
    const [userName,setUserName] = useState('');
    const [password,setPassword] = useState('');
    const { authenticate } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        const isAuthenticated = authenticate(userName, password);
        if (isAuthenticated) {
          navigate("/admin/adminPage"); // Redirect to admin page on success
        } else {
          alert("Invalid username or password");
        }
    };
    const { login,authState } = useAuths();
    return(
        <>
            <div className="container-fluid">
                <div className="admin-container">
                    <div className="loginForm">
                        <div className="wrap-login">
                            <form className="login-data">
                                <h2>Login</h2>
                                <div className="wrap-input">
                                    <span className="label-input">Username</span>
                                    <input className="input100" type="text" value={userName} onChange={(event)=>setUserName(event.target.value)} autoComplete="username"/>
                                </div>
                                <div className="wrap-input">
                                    <span className="label-input">Password</span>
                                    <input className="input100" type="password" value={password} onChange={(event)=>{setPassword(event.target.value)}} autoComplete="current-password"/>
                                </div>
                                {/* <div className="wrap-buttons"> */}
                                  <input type="button" onClick={handleSubmit} className="add-button add-button-continue" value="Login"/>
                                {/* </div> */}
                            </form>
                            {
                                authState?.isAuthenticated?<><button className='oktaLogin' onClick={()=>{navigate('/admin/adminPage')}}>Go to adminPage</button></>:<><button className='oktaLogin' onClick={()=>{login()}}>Okta Login</button></>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}